export const profile = {
  profileFavoritesIconTitle: '즐겨찾기',
  profileEditIconTitle: '편집',
  profileShareIconTitle: '공유',
  profileAdditionalSectionTitle: '추가 정보',
  profileFavoritesCurtainTitle: '즐겨찾기',
  profileFavoriteActionTitle: '즐겨찾기 추가',
  profileFavoritedActionTitle: '즐겨찾기에 추가됨',
  profileMessageAction: '메시지',
  profileCurtainAdd: '추가',
  profileReportUser: '사용자 신고',
  profileReportTitle: '신고',
  profileReportSuccess: '콘텐츠 신고됨',
  profileReset: '초기화',
  profileApply: '적용',
  profileCustomInvalidEmail: '유효한 이메일 주소가 아닙니다',
  profileMaxContentSizeError: '최대 콘텐츠 크기를 초과했습니다!',
  profileMaxAvatarSizeError: '아바타 크기가 너무 큽니다!',
  profileFavoritesCurtainSearchInputText: '검색',
  profileTapShareCurtainOptionTitle: '링크 복사',
  profileTapShareLinkCopiedAlertTitle: '링크가 복사되었습니다!',
  profileQrShareCurtainTitle: '프로필 공유',
  profileQrShareCurtainShareButtonTitle: '공유',
  profileQrShareCurtainCopyButtonTitle: '링크 복사',
  profileQrShareCurtainCopiedAlertTitle: '링크 복사됨!',
  profileQrTapShareProfileCurtainTitle: '프로필 공유',
  profileEditTitle: '편집',
  profileEditPersonalSectionTitle: '개인 정보',
  profileEditContactsSectionTitle: '연락처',
  profileEditSocialSectionTitle: '소셜',
  profileEditAddSocialButtonTitle: '소셜 미디어 추가',
  profileEditAdditionalSectionTitle: '추가 정보',
  profileEditSaveButtonTitle: '저장',
  profileEditSavedAlertTitle: '프로필 저장됨!',
  profileEditEmptyRequiredInputTitle: '값은 비워둘 수 없습니다',
  profileEditEmptyRequiredEmailInputTitle: '공용 이메일은 유효한 이메일 주소가 아닙니다',
  profileEditEmptyRequiredErrorTitle: '뭔가 잘못되었습니다!',
  profileEditSocialsHint: '시작하는 소셜 프로필 URL을 입력하세요',
  preferences: '설정',
  interestedIn: '관심사',
  expertIn: '저는 전문가입니다',
  myPitch: '제 소개',
  qrBadge: 'QR 배지',
  touchpoints: 'Touchpoints',
  lookingFor: '저는 찾고 있습니다',
  topicsToDiscuss: '토론할 주제',
  createNew: '새로 만들기',
  viewTopic: '주제 보기',
  hobbyInterests: '취미와 관심사',
  myNetwork: '내 네트워크',
  seeAll: '모두 보기',
  checkThemOut: '확인해 보세요!',
  activities: '활동',
  oneOnOne: '1:1 미팅',
  Leaderboard: '리더보드',
  learnNetworking: 'Networking Hub에 대해 더 알아보기',
  networkingGroup: '네트워킹 그룹',
  networkingLevel: '네트워킹 수준',
  addNote: '메모 추가',
  notes: '메모',
  enterNote: '메모 입력',
  shareUserProfile: '사용자 프로필 공유',
  flagUser: '사용자 신고'
}
